import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getCafesLoading: false,
  getCafesFailed: false,
  getCafesError: false,
  getCafesMessage: null,
  cafes: [],

  getAmenitiesLoading: false,
  getAmenitiesFailed: false,
  getAmenitiesError: false,
  getAmenitiesMessage: null,
  amenities: [],

  getRegionsLoading: false,
  getRegionsFailed: false,
  getRegionsError: false,
  getRegionsMessage: null,
  regions: [],

  getSpecialServicesLoading: false,
  getSpecialServicesFailed: false,
  getSpecialServicesError: false,
  getSpecialServicesMessage: false,
  specialServices: [],

  addOrEditCafeLoading: false,
  addOrEditCafeFailed: false,
  addOrEditCafeError: false,
  addOrEditCafeMessage: false,
  addOrEditCafeFailedMessagesList: [],

  getCafeByIdLoading: false,
  getCafeByIdFailed: false,
  getCafeByIdError: false,
  getCafeByIdMessage: '',
  fetchedCafeById: null,

  getAllCafeUsersLoading: false,
  getAllCafeUsersFailed: false,
  getAllCafeUsersError: false,
  getAllCafeUsersMessage: '',
  cafeUsersList: [],

  searchedUsersLoading: false,
  searchedUsersFailed: false,
  searchedUsersError: false,
  searchedUsersMessage: '',
  cafeSearchedUser: [],

  assignUserToCafeLoading: false,
  assignUserToCafeError: false,
  assignUserToCafeMessage: null,
  assignUserToCafeFailed: false,

  deleteCafeUserLoading: false,
  deleteCafeUserFailed: false,
  deleteCafeUserError: false,
  deleteCafeUserMessage: null,

  cafeUserDetailsLoading: false,
  cafeUserDetailsError: false,
  cafeUserDetailsMessage: null,
  cafeUserDetailsFailed: false,
  cafeUserDetails: {},

  updateCafeUserLoading: false,
  updateCafeUserError: false,
  updateCafeUserMessage: null,
  updateCafeUserFailed: false,

  cafeByIdForAdminLoading: false,
  cafeByIdForAdminError: false,
  cafeByIdForAdminMessage: null,
  cafeByIdForAdminFailed: false,
  cafeByIdForAdmin: {},

  updateCafeImagesAndLogoForAdminLoading: false,
  updateCafeImagesAndLogoForAdminError: false,
  updateCafeImagesAndLogoForAdminMessage: null,
  updateCafeImagesAndLogoForAdminFailed: false,

  cafeDiscountDetailsLoading: false,
  cafeDiscountDetailsError: false,
  cafeDiscountDetailsMessage: null,
  cafeDiscountDetailsFailed: false,
  cafeDiscountDetails: {},

  cafeNamesListLoading: false,
  cafeNamesListError: false,
  cafeNamesListMessage: null,
  cafeNamesListFailed: false,
  cafeNamesList: [],

  cafe: {
    totalRecords: 0,
  },

  getCafesContractLoading: false,
  getCafesContractFailed: false,
  getCafesContractError: false,
  getCafesContractMessage: null,
  cafesContract: [],
  cafeContractId: {
    totalRecords: 0,
  },

  getCafesExcelFileLoading: false,
  getCafesExcelFileFailed: false,
  getCafesExcelFileError: false,
  getCafesExcelFileFailedMessage: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_CAFES_LOADING: {
      return {
        ...state,
        getCafesLoading: true,
        getCafesFailed: false,
        getCafesError: false,
        getCafesMessage: null,
        cafes: [],
      };
    }
    case actionTypes.GET_CAFES_SUCCESS: {
      return {
        ...state,
        getCafesLoading: false,
        getCafesFailed: false,
        getCafesError: false,
        getCafesMessage: null,
        cafe: {
          ...action.payload,
        },
        cafes: [...action.payload.cafes],
      };
    }
    case actionTypes.GET_CAFES_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getCafesLoading: false,
        getCafesFailed: true,
        getCafesError: false,
        getCafesMessage: message,
      };
    }
    case actionTypes.GET_CAFES_REJECT: {
      return {
        ...state,
        getCafesLoading: false,
        getCafesFailed: false,
        getCafesError: true,
        getCafesMessage: null,
      };
    }
    case actionTypes.GET_AMENITIES_LOADING: {
      return {
        ...state,
        getAmenitiesLoading: true,
        getAmenitiesFailed: false,
        getAmenitiesError: false,
        getAmenitiesMessage: null,
        amenities: [],
      };
    }
    case actionTypes.GET_AMENITIES_SUCCESS: {
      return {
        ...state,
        getAmenitiesLoading: false,
        getAmenitiesFailed: false,
        getAmenitiesError: false,
        getAmenitiesMessage: false,
        amenities: [...action.payload],
      };
    }
    case actionTypes.GET_AMENITIES_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getAmenitiesLoading: false,
        getAmenitiesFailed: true,
        getAmenitiesError: false,
        getAmenitiesMessage: message,
      };
    }
    case actionTypes.GET_AMENITIES_REJECT: {
      return {
        ...state,
        getAmenitiesLoading: false,
        getAmenitiesFailed: false,
        getAmenitiesError: true,
      };
    }
    case actionTypes.GET_REGIONS_LOADING: {
      return {
        ...state,
        getRegionsLoading: true,
        getRegionsFailed: false,
        getRegionsError: false,
        getRegionsMessage: null,
        regions: [],
      };
    }
    case actionTypes.GET_REGIONS_SUCCESS: {
      return {
        ...state,
        getRegionsLoading: false,
        regions: action.payload.regions.sort((a, b) => {
          if (a.name > b.name) {
            return 1;
          } else if (a.name < b.name) {
            return -1;
          }
          return 0;
        }),
      };
    }
    case actionTypes.GET_REGIONS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getRegionsLoading: false,
        getRegionsFailed: true,
        getRegionsMessage: message,
      };
    }
    case actionTypes.GET_REGIONS_REJECT: {
      return {
        ...state,
        getRegionsLoading: false,
        getRegionsError: true,
      };
    }
    case actionTypes.GET_SPECIAL_SERVICES_LOADING: {
      return {
        ...state,
        getSpecialServicesLoading: true,
        getSpecialServicesFailed: false,
        getSpecialServicesError: false,
        getSpecialServicesMessage: false,
        specialServices: [],
      };
    }
    case actionTypes.GET_SPECIAL_SERVICES_SUCCESS: {
      return {
        ...state,
        getSpecialServicesLoading: false,
        specialServices: [...action.payload],
      };
    }
    case actionTypes.GET_SPECIAL_SERVICES_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getSpecialServicesLoading: false,
        getSpecialServicesFailed: true,
        getSpecialServicesMessage: message,
      };
    }
    case actionTypes.GET_SPECIAL_SERVICES_REJECT: {
      return {
        ...state,
        getSpecialServicesLoading: false,
        getSpecialServicesError: true,
      };
    }

    case actionTypes.CLEAR_ADD_OR_EDIT_CAFE_FORM: {
      return {
        ...state,
        addOrEditCafeLoading: false,
        addOrEditCafeFailed: false,
        addOrEditCafeError: false,
        addOrEditCafeMessage: '',
        addOrEditCafeFailedMessagesList: [],
      };
    }

    case actionTypes.INSERT_NEW_CAFE_LOADING: {
      return {
        ...state,
        addOrEditCafeLoading: true,
        addOrEditCafeFailed: false,
        addOrEditCafeError: false,
        addOrEditCafeMessage: '',
        addOrEditCafeFailedMessagesList: [],
      };
    }
    case actionTypes.INSERT_NEW_CAFE_FAILED: {
      const { message, errors } = action.payload;
      return {
        ...state,
        addOrEditCafeLoading: false,
        addOrEditCafeFailed: true,
        addOrEditCafeError: false,
        addOrEditCafeMessage: message,
        addOrEditCafeFailedMessagesList: errors || [],
      };
    }
    case actionTypes.INSERT_NEW_CAFE_REJECT: {
      return {
        ...state,
        addOrEditCafeLoading: false,
        addOrEditCafeFailed: false,
        addOrEditCafeError: true,
        addOrEditCafeFailedMessagesList: [],
      };
    }
    case actionTypes.INSERT_NEW_CAFE_SUCCESS: {
      return {
        ...state,
        addOrEditCafeLoading: false,
        addOrEditCafeFailed: false,
        addOrEditCafeError: false,
        addOrEditCafeFailedMessagesList: [],
      };
    }
    case actionTypes.UPDATE_CAFE_LOADING: {
      return {
        ...state,
        addOrEditCafeLoading: true,
        addOrEditCafeFailed: false,
        addOrEditCafeError: false,
        addOrEditCafeMessage: '',
        addOrEditCafeFailedMessagesList: [],
      };
    }
    case actionTypes.UPDATE_CAFE_FAILED: {
      const { message, errors } = action.payload;
      return {
        ...state,
        addOrEditCafeLoading: false,
        addOrEditCafeFailed: true,
        addOrEditCafeError: false,
        addOrEditCafeMessage: message,
        addOrEditCafeFailedMessagesList: errors || [],
      };
    }
    case actionTypes.UPDATE_CAFE_REJECT: {
      return {
        ...state,
        addOrEditCafeLoading: false,
        addOrEditCafeFailed: false,
        addOrEditCafeError: true,
        addOrEditCafeFailedMessagesList: [],
      };
    }
    case actionTypes.UPDATE_CAFE_SUCCESS: {
      return {
        ...state,
        addOrEditCafeLoading: false,
        addOrEditCafeFailed: false,
        addOrEditCafeError: false,
        addOrEditCafeFailedMessagesList: [],
      };
    }
    case actionTypes.GET_CAFE_BY_ID_LOADING: {
      return {
        ...state,
        getCafeByIdLoading: true,
        getCafeByIdFailed: false,
        getCafeByIdError: false,
        fetchedCafeById: null,
      };
    }
    case actionTypes.GET_CAFE_BY_ID_FAILURE: {
      const { message } = action.payload;
      return {
        ...state,
        getCafeByIdLoading: false,
        getCafeByIdFailed: true,
        getCafeByIdError: false,
        getCafeByIdMessage: message,
        fetchedCafeById: null,
      };
    }
    case actionTypes.GET_CAFE_BY_ID_REJECT: {
      return {
        ...state,
        getCafeByIdLoading: false,
        getCafeByIdFailed: false,
        getCafeByIdError: true,
        getCafeByIdMessage: '',
        fetchedCafeById: null,
      };
    }
    case actionTypes.GET_CAFE_BY_ID_SUCCESS: {
      return {
        ...state,
        getCafeByIdLoading: false,
        getCafeByIdFailed: false,
        getCafeByIdError: false,
        getCafeByIdMessage: '',
        fetchedCafeById: {
          ...action.payload,
          workingHours:
            action.payload.workingHours &&
            action.payload.workingHours.length &&
            action.payload.workingHours.map(x => ({
              ...x,
              fromTime: x.fromTime.substring(0, 5),
              toTime: x.toTime.substring(0, 5),
            })),
        },
      };
    }
    case actionTypes.FETCH_ALL_CAFE_USERS_SUCCESSFULL: {
      return {
        ...state,
        getAllCafeUsersLoading: false,
        getAllCafeUsersFailed: false,
        getAllCafeUsersError: false,
        getAllCafeUsersMessage: '',
        cafeUsersList: { ...action.payload },
      };
    }
    case actionTypes.FETCH_ALL_CAFE_USERS_FAILURE: {
      const { message } = action.payload;
      return {
        ...state,
        getAllCafeUsersLoading: false,
        getAllCafeUsersFailed: true,
        getAllCafeUsersError: false,
        getAllCafeUsersMessage: message,
        cafeUsersList: [],
      };
    }
    case actionTypes.FETCH_ALL_CAFE_USERS_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        getAllCafeUsersLoading: false,
        getAllCafeUsersFailed: false,
        getAllCafeUsersError: true,
        getAllCafeUsersMessage: '',
        cafeUsersList: [],
      };
    }
    case actionTypes.FETCH_ALL_CAFE_USERS_LOADING: {
      const { message } = action.payload;
      return {
        ...state,
        getAllCafeUsersLoading: true,
        getAllCafeUsersFailed: false,
        getAllCafeUsersError: false,
        getAllCafeUsersMessage: '',
        cafeUsersList: [],
      };
    }
    case actionTypes.FETCH_CAFE_SEARCHED_USER_LOADING: {
      const { message } = action.payload;
      return {
        ...state,
        searchedUsersLoading: true,
        searchedUsersFailed: false,
        searchedUsersError: false,
        searchedUsersMessage: null,
        searchedUsers: {},
        searchedUsersList: [],
      };
    }
    case actionTypes.FETCH_CAFE_SEARCHED_USER_SUCCESSFULL: {
      const { message } = action.payload;
      return {
        ...state,
        searchedUsersLoading: false,
        searchedUsersFailed: false,
        searchedUsersError: false,
        searchedUsersMessage: null,
        searchedUsers: { ...action.payload },
        searchedUsersList: [...action.payload.users],
      };
    }
    case actionTypes.FETCH_CAFE_SEARCHED_USER_FAILURE: {
      const { message } = action.payload;
      return {
        ...state,
        searchedUsersLoading: false,
        searchedUsersFailed: true,
        searchedUsersError: false,
        searchedUsersMessage: message,
        searchedUsers: {},
        searchedUsersList: [],
      };
    }
    case actionTypes.FETCH_CAFE_SEARCHED_USER_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        searchedUsersLoading: false,
        searchedUsersFailed: false,
        searchedUsersError: true,
        searchedUsersMessage: null,
        searchedUsers: {},
        searchedUsersList: [],
      };
    }
    case actionTypes.CHANGE_CAFE_STATUS_LOADING: {
      return {
        ...state,
        changeCafeStatusLoading: true,
        changeCafeStatusFailed: false,
        changeCafeStatusError: false,
      };
    }
    case actionTypes.CHANGE_CAFE_STATUS_SUCCESS: {
      const ix = state.cafes.findIndex(x => x.id === action.payload.cafeId);
      const clonedCafes = [...state.cafes];
      clonedCafes[ix].status = action.payload.status;

      return {
        ...state,
        cafes: clonedCafes,
        changeCafeStatusLoading: false,
        changeCafeStatusFailed: false,
        changeCafeStatusError: false,
        changeCafeStatusMessage: null,
      };
    }
    case actionTypes.CHANGE_CAFE_STATUS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        changeCafeStatusLoading: false,
        changeCafeStatusFailed: true,
        changeCafeStatusError: false,
        changeCafeStatusMessage: message,
      };
    }
    case actionTypes.CHANGE_CAFE_STATUS_REJECT: {
      return {
        ...state,
        changeCafeStatusLoading: false,
        changeCafeStatusFailed: false,
        changeCafeStatusError: true,
        changeCafeStatusMessage: null,
      };
    }
    case actionTypes.DELETE_CAFE_USER_LOADING: {
      return {
        ...state,
        deleteCafeUserLoading: true,
        deleteCafeUserFailed: false,
        deleteCafeUserError: false,
        deleteCafeUserMessage: null,
      };
    }
    case actionTypes.DELETE_CAFE_USER_SUCCESS: {
      return {
        ...state,
        deleteCafeUserLoading: false,
        deleteCafeUserFailed: false,
        deleteCafeUserError: false,
        deleteCafeUserMessage: null,
      };
    }
    case actionTypes.DELETE_CAFE_USER_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        deleteCafeUserLoading: false,
        deleteCafeUserFailed: true,
        deleteCafeUserError: false,
        deleteCafeUserMessage: message,
      };
    }
    case actionTypes.DELETE_CAFE_USER_REJECT: {
      return {
        ...state,
        deleteCafeUserLoading: false,
        deleteCafeUserFailed: false,
        deleteCafeUserError: true,
        deleteCafeUserMessage: null,
      };
    }
    case actionTypes.ASSIGN_USER_TO_CAFE_LOADING: {
      return {
        ...state,
        assignUserToCafeLoading: true,
        assignUserToCafeError: false,
        assignUserToCafeMessage: null,
        assignUserToCafeFailed: false,
      };
    }
    case actionTypes.ASSIGN_USER_TO_CAFE_SUCCESSFULL: {
      return {
        ...state,
        assignUserToCafeLoading: false,
        assignUserToCafeError: false,
        assignUserToCafeMessage: null,
        assignUserToCafeFailed: false,
      };
    }
    case actionTypes.ASSIGN_USER_TO_CAFE_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        assignUserToCafeLoading: false,
        assignUserToCafeError: false,
        assignUserToCafeMessage: message,
        assignUserToCafeFailed: true,
      };
    }
    case actionTypes.ASSIGN_USER_TO_CAFE_REJECT: {
      return {
        ...state,
        assignUserToCafeLoading: false,
        assignUserToCafeError: true,
        assignUserToCafeMessage: null,
        assignUserToCafeFailed: false,
      };
    }
    case actionTypes.FETCH_CAFE_USER_DETAILS_LOADING: {
      return {
        ...state,
        cafeUserDetailsLoading: true,
        cafeUserDetailsError: false,
        cafeUserDetailsMessage: null,
        cafeUserDetailsFailed: false,
        cafeUserDetails: {},
      };
    }
    case actionTypes.FETCH_CAFE_USER_DETAILS_SUCCESS: {
      return {
        ...state,
        cafeUserDetailsLoading: false,
        cafeUserDetailsError: false,
        cafeUserDetailsMessage: null,
        cafeUserDetailsFailed: false,
        cafeUserDetails: { ...action.payload },
      };
    }
    case actionTypes.FETCH_CAFE_USER_DETAILS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        cafeUserDetailsLoading: false,
        cafeUserDetailsError: false,
        cafeUserDetailsMessage: message,
        cafeUserDetailsFailed: true,
        cafeUserDetails: {},
      };
    }
    case actionTypes.FETCH_CAFE_USER_DETAILS_REJECT: {
      return {
        ...state,
        cafeUserDetailsLoading: false,
        cafeUserDetailsError: true,
        cafeUserDetailsMessage: null,
        cafeUserDetailsFailed: false,
        cafeUserDetails: {},
      };
    }
    case actionTypes.UPDATE_CAFE_USER_LOADING: {
      return {
        ...state,
        updateCafeUserLoading: true,
        updateCafeUserError: false,
        updateCafeUserMessage: null,
        updateCafeUserFailed: false,
      };
    }
    case actionTypes.UPDATE_CAFE_USER_SUCCESS: {
      return {
        ...state,
        updateCafeUserLoading: false,
        updateCafeUserError: false,
        updateCafeUserMessage: null,
        updateCafeUserFailed: false,
      };
    }
    case actionTypes.UPDATE_CAFE_USER_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        updateCafeUserLoading: false,
        updateCafeUserError: false,
        updateCafeUserMessage: message,
        updateCafeUserFailed: true,
      };
    }
    case actionTypes.UPDATE_CAFE_USER_REJECT: {
      return {
        ...state,
        updateCafeUserLoading: false,
        updateCafeUserError: true,
        updateCafeUserMessage: null,
        updateCafeUserFailed: false,
      };
    }
    case actionTypes.GET_CAFE_BY_ID_FOR_ADMIN_LOADING: {
      return {
        ...state,
        cafeByIdForAdminLoading: true,
        cafeByIdForAdminError: false,
        cafeByIdForAdminMessage: null,
        cafeByIdForAdminFailed: false,
        cafeByIdForAdmin: {},
      };
    }
    case actionTypes.GET_CAFE_BY_ID_FOR_ADMIN_SUCCESS: {
      return {
        ...state,
        cafeByIdForAdminLoading: false,
        cafeByIdForAdminError: false,
        cafeByIdForAdminMessage: null,
        cafeByIdForAdminFailed: false,
        cafeByIdForAdmin: { ...action.payload },
      };
    }
    case actionTypes.GET_CAFE_BY_ID_FOR_ADMIN_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        cafeByIdForAdminLoading: false,
        cafeByIdForAdminError: false,
        cafeByIdForAdminMessage: message,
        cafeByIdForAdminFailed: true,
        cafeByIdForAdmin: {},
      };
    }
    case actionTypes.GET_CAFE_BY_ID_FOR_ADMIN_REJECT: {
      return {
        ...state,
        cafeByIdForAdminLoading: false,
        cafeByIdForAdminError: true,
        cafeByIdForAdminMessage: null,
        cafeByIdForAdminFailed: false,
        cafeByIdForAdmin: {},
      };
    }
    case actionTypes.UPDATE_CAFE_IMAGES_AND_LOGO_FOR_ADMIN_LOADING: {
      return {
        ...state,
        updateCafeImagesAndLogoForAdminLoading: true,
        updateCafeImagesAndLogoForAdminError: false,
        updateCafeImagesAndLogoForAdminMessage: null,
        updateCafeImagesAndLogoForAdminFailed: false,
      };
    }
    case actionTypes.UPDATE_CAFE_IMAGES_AND_LOGO_FOR_ADMIN_SUCCESS: {
      return {
        ...state,
        updateCafeImagesAndLogoForAdminLoading: false,
        updateCafeImagesAndLogoForAdminError: false,
        updateCafeImagesAndLogoForAdminMessage: null,
        updateCafeImagesAndLogoForAdminFailed: false,
      };
    }
    case actionTypes.UPDATE_CAFE_IMAGES_AND_LOGO_FOR_ADMIN_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        updateCafeImagesAndLogoForAdminLoading: false,
        updateCafeImagesAndLogoForAdminError: false,
        updateCafeImagesAndLogoForAdminMessage: message,
        updateCafeImagesAndLogoForAdminFailed: true,
      };
    }
    case actionTypes.UPDATE_CAFE_IMAGES_AND_LOGO_FOR_ADMIN_REJECT: {
      return {
        ...state,
        updateCafeImagesAndLogoForAdminLoading: false,
        updateCafeImagesAndLogoForAdminError: true,
        updateCafeImagesAndLogoForAdminMessage: null,
        updateCafeImagesAndLogoForAdminFailed: false,
      };
    }
    case actionTypes.FETCH_CAFE_DISCOUNT_BY_ID_LOADING: {
      return {
        ...state,
        cafeDiscountDetailsLoading: true,
        cafeDiscountDetailsError: false,
        cafeDiscountDetailsMessage: null,
        cafeDiscountDetailsFailed: false,
        cafeDiscountDetails: {},
      };
    }
    case actionTypes.FETCH_CAFE_DISCOUNT_BY_ID_SUCCESS: {
      return {
        ...state,
        cafeDiscountDetailsLoading: false,
        cafeDiscountDetailsError: false,
        cafeDiscountDetailsMessage: null,
        cafeDiscountDetailsFailed: false,
        cafeDiscountDetails: { ...action.payload },
      };
    }
    case actionTypes.FETCH_CAFE_DISCOUNT_BY_ID_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        cafeDiscountDetailsLoading: false,
        cafeDiscountDetailsError: false,
        cafeDiscountDetailsMessage: message,
        cafeDiscountDetailsFailed: true,
        cafeDiscountDetails: {},
      };
    }
    case actionTypes.FETCH_CAFE_DISCOUNT_BY_ID_REJECT: {
      return {
        ...state,
        cafeDiscountDetailsLoading: false,
        cafeDiscountDetailsError: true,
        cafeDiscountDetailsMessage: null,
        cafeDiscountDetailsFailed: false,
        cafeDiscountDetails: {},
      };
    }

    case actionTypes.GET_ALL_CAFE_NAMES_FOR_PANEL_LOADING: {
      return {
        ...state,
        cafeNamesListLoading: true,
        cafeNamesListError: false,
        cafeNamesListMessage: null,
        cafeNamesListFailed: false,
        cafeNamesList: [],
      };
    }
    case actionTypes.GET_ALL_CAFE_NAMES_FOR_PANEL_SUCCESS: {
      return {
        ...state,
        cafeNamesListLoading: false,
        cafeNamesListError: false,
        cafeNamesListMessage: null,
        cafeNamesListFailed: false,
        cafeNamesList: [...action.payload].sort((a, b) => {
          if (a.name > b.name) {
            return 1;
          } else if (a.name < b.name) {
            return -1;
          } else {
            return 0;
          }
        }),
      };
    }
    case actionTypes.GET_ALL_CAFE_NAMES_FOR_PANEL_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        cafeNamesListLoading: false,
        cafeNamesListError: false,
        cafeNamesListMessage: message,
        cafeNamesListFailed: true,
        cafeNamesList: [],
      };
    }
    case actionTypes.GET_ALL_CAFE_NAMES_FOR_PANEL_REJECT: {
      return {
        ...state,
        cafeNamesListLoading: false,
        cafeNamesListError: true,
        cafeNamesListMessage: null,
        cafeNamesListFailed: false,
        cafeNamesList: [],
      };
    }

    case actionTypes.GET_CAFES_EXCEL_FILE_LOADING: {
      return {
        ...state,
        getCafesExcelFileLoading: true,
        getCafesExcelFileFailed: false,
        getCafesExcelFileError: false,
        getCafesExcelFileFailedMessage: null,
      };
    }
    case actionTypes.GET_CAFES_EXCEL_FILE_SUCCESS: {
      return {
        ...state,
        getCafesExcelFileLoading: false,
        getCafesExcelFileFailed: false,
        getCafesExcelFileError: false,
        getCafesExcelFileFailedMessage: null,
      };
    }
    case actionTypes.GET_CAFES_EXCEL_FILE_FAILED: {
      // const { message } = action.payload;

      return {
        ...state,
        getCafesExcelFileLoading: false,
        getCafesExcelFileFailed: true,
        getCafesExcelFileError: false,
        getCafesExcelFileFailedMessage: null,
      };
    }
    case actionTypes.GET_CAFES_EXCEL_FILE_REJECT: {
      return {
        ...state,
        getCafesExcelFileLoading: false,
        getCafesExcelFileFailed: false,
        getCafesExcelFileError: true,
        getCafesExcelFileFailedMessage: null,
      };
    }

    case actionTypes.GET_CAFES_CONTRACT_LOADING: {
      return {
        ...state,
        getCafesContractLoading: true,
        getCafesContractFailed: false,
        getCafesContractError: false,
        getCafesContractMessage: null,
        cafesContract: [],
      };
    }
    case actionTypes.GET_CAFES_CONTRACT_SUCCESS: {
      return {
        ...state,
        getCafesContractLoading: false,
        getCafesContractFailed: false,
        getCafesContractError: false,
        getCafesContractMessage: null,
        cafeContractId: {
          ...action.payload,
        },
        cafesContract: [...action.payload.cafes],
      };
    }
    case actionTypes.GET_CAFES_CONTRACT_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getCafesContractLoading: false,
        getCafesContractFailed: true,
        getCafesContractError: false,
        getCafesContractMessage: message,
      };
    }
    case actionTypes.GET_CAFES_CONTRACT_REJECT: {
      return {
        ...state,
        getCafesContractLoading: false,
        getCafesContractFailed: false,
        getCafesContractError: true,
        getCafesContractMessage: null,
      };
    }

    default:
      return state;
  }
};
